module.exports = __webpack_public_path__ + "img/1.538bf7fe.jpg";